export const initialAppendixesState = {
  appendixes: [],
  appendixTypes: []
};

export interface IAppendixesState {
  appendixes: any[],
  appendixTypes: any[]
}
